import { createContext, type ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

export type TopBarSlots = { breadcrumb: HTMLElement | null; actions: HTMLElement | null };

export const TopBarContext = createContext<TopBarSlots>({ breadcrumb: null, actions: null });

function Slot({ name, children }: { name: keyof TopBarSlots; children: ReactNode }) {
  const node = useContext(TopBarContext)[name];
  return node ? createPortal(children, node) : null;
}

/** Renders its children on the left of the shell's top bar. Use from a page, with `Breadcrumb`. */
export function TopBarBreadcrumb({ children }: { children: ReactNode }) {
  return <Slot name="breadcrumb">{children}</Slot>;
}

/** Renders its children on the right of the shell's top bar: page actions or view tabs. */
export function TopBarActions({ children }: { children: ReactNode }) {
  return <Slot name="actions">{children}</Slot>;
}
